module.exports = __webpack_public_path__ + "img/9.879c625d.jpg";